import { useLang } from '@/i18n';
import css from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';
import { ItfItem } from './type';

const I: React.FC = () => {
    const { t } = useLang('ces2026.I');
    const items: ItfItem[] = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1766476073486/Jennette%20H.jpg',
            text: t('item1_text'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1766476073663/Justen%20S.jpg',
            text: t('item2_text'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1766476073866/Johnny%20M.jpg',
            text: t('item3_text'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1766476074468/Ariene%20C.jpg',
            text: t('item4_text'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1767000202655/Ken.jpg',
            text: t('item5_text'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1766476074212/Ross%20D.jpg',
            text: t('item6_text'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1766476073352/Dr.%20Hal.jpg',
            text: t('item7_text'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1766476073040/Tim%20V.jpg',
            text: t('item8_text'),
        },
    ];

    return (
        <div id="ces-2026-I" className={`ces-2026-I ${css.section} GtmModuleData-section`} data-section-id={'ces-2026-I'}>
            <div className="info">
                <h2 className="title">{t('title')}</h2>
            </div>
            <div className="box">
                <ul className="items">
                    {[...items, ...items]?.map((item: ItfItem, i: number) => (
                        <li className="item" key={i}>
                            <div className="item-img">
                                <EcoImg pc={item.img} />
                            </div>
                            <p className="item-text text">{item.text}</p>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default I;
